import reducerRegistry from 'reduxUtils/reducerRegistry';
import makeRequest from 'utils/makeRequest';
import { receiveAdsData } from 'helpers/ads/revenueRedux';
import { getJarvisFeedURL } from '../../utils/common';

const reducerName = 'landing';
const createActionName = name => `toi/${reducerName}/${name}`;

export const RECEIVE_NEWS_LISTING_PAGE_DATA = createActionName(
  'RECEIVE_NEWS_LISTING_PAGE_DATA',
);

export const HANDLE_NEWS_LISTING_PAGE_DATA_ERROR = createActionName(
  'HANDLE_NEWS_LISTING_PAGE_DATA_ERROR',
);

export const DATA_LOADING = createActionName('DATA_LOADING');
export const DATA_LOADED = createActionName('DATA_LOADED');

const getLandingPageJarvisFeedUrl = (
  path,
  isMobile,
  isPrime,
  isAffiliatePage,
) => {
  const platformVal = isMobile ? 'mweb' : 'web';
  const pathParam = path ? `&path=${path}` : '';
  const primeParam = isPrime ? `&prime=yes` : '';
  const platformParam = `&platform=${platformVal}`;
  const client = isAffiliatePage ? 'affiliates' : 'toi';

  return getJarvisFeedURL(
    `/${client}/page_landing`,
    `${pathParam}${primeParam}${platformParam}`,
  );
  // return `http://172.29.11.111:1337/v1/feeds/toi/page_landing?db_env=${dbEnv}${pathParam}${primeParam}${platformParam}&cache_policy=cache_by_pass`;
};

function fetchNewsListingData(params) {
  // Web:
  // 1. Nonprime: https://jarvis.indiatimes.com/v1/feeds/toi/page_landing?db_env=drafts&path=/sports&platform=web
  // 2. prime: https://jarvis.indiatimes.com/v1/feeds/toi/page_landing?db_env=drafts&path=/sports&prime=yes&platform=web
  // MWeb:
  // 1. Nonprime: https://jarvis.indiatimes.com/v1/feeds/toi/page_landing?db_env=drafts&path=/sports&platform=mweb
  // 2. prime: https://jarvis.indiatimes.com/v1/feeds/toi/page_landing?db_env=drafts&path=/sports&prime=yes&platform=mweb

  const url = getLandingPageJarvisFeedUrl(
    params.fullPath,
    params.isWapView,
    params.isPrime,
    params.isAffiliatePage,
  );
  // console.log('testjarvis url1:', url);
  return makeRequest.get(url, {}, 'skipfeedengine');
}

export function reciveNewsListingData(data) {
  return {
    type: RECEIVE_NEWS_LISTING_PAGE_DATA,
    payload: data,
  };
}

export function dataLoading() {
  return {
    type: DATA_LOADING,
    payload: {},
  };
}

export function dataLoaded() {
  return {
    type: DATA_LOADED,
    payload: {},
  };
}

function handleNewsListingPageDataError() {
  return {
    type: HANDLE_NEWS_LISTING_PAGE_DATA_ERROR,
    payload: {},
  };
}

export function loadNewsListingPageData(params) {
  console.log('inside loadinggg');
  return dispatch =>
    fetchNewsListingData(params)
      .then(response => {
        console.log('test:', response);
        dispatch(reciveNewsListingData(response.data, params));
        if (response.data && response.data.revenue) {
          dispatch(receiveAdsData(response.data.revenue));
        }
      })
      .catch(error => {
        dispatch(handleNewsListingPageDataError(error));
      });
}

export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case DATA_LOADING: {
      return {
        ...state,
        dataLoading: true,
      };
    }
    case DATA_LOADED: {
      return {
        ...state,
        dataLoading: false,
      };
    }
    case RECEIVE_NEWS_LISTING_PAGE_DATA: {
      return {
        ...state,
        data: action.payload,
      };
    }
    default:
      return state;
  }
}

reducerRegistry.register(reducerName, reducer);
